import React from 'react'
import Manager from 'tyan/public/components/Manager'
import AdvanceOrder from './AdvanceOrder'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '预支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
        { _text: '预支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
        { _float: '支付金额', field: 'AdvanceAmount', minWidth: 150, flex: 1, zeroValue: null, search: true },
        { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
        { _text: '请购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
        { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
        { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
        { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
        { _: 'taskName', field: 'Task.TaskName' }
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <AdvanceOrder {...props} id={data.id} taskName={data.taskName} />)
    }
}

export default props => <Manager {...props} config={config} />